import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { createUserEdit } from '../users/UserEdit';
import { createUserList } from '../users/UserList';

const CoachUsersList = createUserList({
    resource: 'admin/user-management/coach-users',
    showRoleFilter: false,
    showImport: false,
    mode: 'coach',
});

const CoachUsersEdit = createUserEdit({
    resource: 'admin/user-management/coach-users',
    cancelPath: '/admin/user-management/coach-users',
    mode: 'coach',
});

export default {
    list: CoachUsersList,
    edit: CoachUsersEdit,
    icon: SupportAgentIcon,
    recordRepresentation: (record: any) => record.name || record.email,
};